export const SENTRY_DSN =
  "https://562ffbca9156c7709202f84f7b0174de@o4503972059086848.ingest.us.sentry.io/4510029125582848";
